export default "__VITE_ASSET__DstxUHPm__"